
import { OnboardingLayout } from "./onboarding-layout";
import { navigatePath } from "../nav/actions";
import { dataToStore, dataToDynamo, loadOnboardingData, clearOnboardingItem,
  UploadFile, setOnboardingData } from "./actions";
import { appIsLoading } from "../app/actions";
import {setAccountState, createOnboardingToken, updateUserNameRedux} from "../login/login/actions";
import { verifyDwollaCustomer, setLoading, refreshDwolla, dwollaUpdate } from "../payment/actions";
import { connect } from "react-redux";
import { updateGovernorData } from "../governor/actions";
import { tdaUpdate } from "../tda/actions";
import {addUserPaymentItem, GetPaymentInformation} from "../components/PaymentsDashboard/action";
import {loadUserSecurityItems} from "../superadmin/security-purchase-reducer";

const mapDispatchToProps = dispatch => {
  return {
    dataToDynamo: (data, index, done, disable_load, username, identity_id) => dispatch(
      dataToDynamo(data, index, done, disable_load, username, identity_id)),
    dataToStore: (data, index, username) => dispatch(dataToStore(data, index, username)),
    navigatePath: (path, args) => dispatch(navigatePath(path, args)),
    appIsLoading: is_loading => dispatch(appIsLoading(is_loading)),
    loadOnboardingData: (index, username) => dispatch(loadOnboardingData(index, username)),
    clearOnboardingItem: (index, prms, username) => dispatch(clearOnboardingItem(index, prms, username)),
    setOnboardingData: (onboarding, index) => dispatch(setOnboardingData(onboarding, index)),
    setAccountState: (account_state, index) => dispatch(setAccountState(account_state, index)),
    createOnboardingToken: token => dispatch(createOnboardingToken(token)),
    verifyDwollaCustomer: () => dispatch(verifyDwollaCustomer()),
    setDwollaLoading: (index, loading) => dispatch(setLoading(index, loading)),
    UploadFile: (file, index, path) => dispatch(UploadFile(file, index, path)),
    refreshDwolla: (index, username) => dispatch(refreshDwolla(index, username)),
    dwollaUpdate: (data, index) => dispatch(dwollaUpdate(data, index)),
    updateGovernorData: (data) => dispatch(updateGovernorData(data)),
    tdaUpdate: (tda, index) => dispatch(tdaUpdate(tda, index)),
    updateUserNameRedux: (first_name, last_name) => dispatch(updateUserNameRedux(first_name, last_name)),
    addUserPaymentItem: (username, payment_item) => dispatch(addUserPaymentItem(username, payment_item)),
    GetPaymentInformation: username => dispatch(GetPaymentInformation(username)),
    loadUserSecurityItems: (username) => dispatch(loadUserSecurityItems(username)),
  }
};

const mapStateToProps = state => {
  return {
    onboarding: state.onboarding,
    tda: state.tda,
    client: state.client,
    wlf: state.app.wlf,
    config: state.app.config,
    token: state.user.token,
    onboarding_token: state.user.onboarding_token,
    user: state.user,
    account_state: state.user.account_state,
    isFetching: state.user.isFetching,
    dwolla: state.dwolla,
    governor: state.governor,
    app: state.app,
    cdOffering: state.cdOffering,
    securityPurchase: state.securityPurchase,
    userPayments: state.userPayments,
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(OnboardingLayout);
